<template>
  <svg
    :width="width ? width : height ? height : 25"
    :height="height ? height : width ? width : 17"
    viewBox="0 0 25 17"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24.5551 7.806C22.2955 3.3974 17.8222.4145 12.7001.4145c-5.122 0-9.5967 2.985-11.855 7.3921a1.348 1.348 0 0 0 0 1.2163c2.2596 4.4087 6.733 7.3916 11.855 7.3916 5.1221 0 9.5967-2.985 11.855-7.392a1.348 1.348 0 0 0 0-1.2163zm-11.855 6.6084c-3.3137 0-6-2.6863-6-6s2.6863-6 6-6 6 2.6863 6 6a5.997 5.997 0 0 1-6 6zm0-10a3.9713 3.9713 0 0 0-1.0546.158c.584.7935.5007 1.8947-.196 2.5914-.6967.6967-1.7979.78-2.5915.196-.4484 1.652.2067 3.406 1.6282 4.3596 1.4215.9536 3.2929.8945 4.6514-.147 1.3585-1.0414 1.9015-2.8332 1.3497-4.4536-.5518-1.6204-2.0754-2.7084-3.7872-2.7044z"
      :fill="iconColor"
      fill-rule="nonzero"
    />
  </svg>
</template>

<script>
export default {
  name: 'filled-circle-eye',
  props: {
    iconColor: {
      type: String,
      default: '#BB5CEE',
    },
    height: {
      type: Number,
      required: false,
    },
    width: {
      type: Number,
      required: false,
    },
  },
};
</script>
